module.exports = __webpack_public_path__ + "img/staple-food.184a7ec5.svg";